import {
  accountColumnDefinition,
  balanceColumnDefinition,
  oneByOneBalanceColumnDefinition,
  countryTaxTypeColumnDefinition,
  disallowedAmountColumnDefinition,
  disallowedAmountTotalColumnDefinition,
  disallowedPercentageColumnDefinition,
  proportionOfTaxColumnDefinition,
  ytdAmountColumnDefinition,
} from '../columnDefinitions';

import {
  alignLeftCellStyle,
} from '@common/cellStyles';

export const nonMultitaxColumnDefs = [
  accountColumnDefinition,
  countryTaxTypeColumnDefinition,
  oneByOneBalanceColumnDefinition,
  { ...ytdAmountColumnDefinition },
  balanceColumnDefinition,
  disallowedPercentageColumnDefinition,
  { ...disallowedAmountColumnDefinition, field: 'disallowedAmt' },
];

export const multitaxColumnDefs = [
  ...nonMultitaxColumnDefs,
  proportionOfTaxColumnDefinition,
  disallowedAmountTotalColumnDefinition,
];

export const creditColumnDefs = [
  { ...accountColumnDefinition, headerName: 'Credits and Other After Tax Adjustments', ...alignLeftCellStyle },
  { ...disallowedAmountColumnDefinition, headerName: 'Amount', field: 'disallowedAmtTotal' },
];

export const stateAdjustmentColumnDefs = [
  ...nonMultitaxColumnDefs,
];

export const defCreditColumnDefs = [
  { ...accountColumnDefinition, headerName: 'After Tax Deferred Tax Expense', ...alignLeftCellStyle },
  { ...disallowedAmountColumnDefinition, headerName: 'Amount', field: 'disallowedAmtTotal' },
];
